<template>
  <div class="view-area-box" :class="{ 'fit-height': fitMode === 'height' }">
    <div class="view-area">
      <div class="view" :style="viewStyle">
        <div class="mask-top"
          :style="activeItemData ? activeItemData.maskStyle.top : null"></div>
        <div class="mask-bottom"
          :style="activeItemData ? activeItemData.maskStyle.bottom : null"></div>
        <template v-if="activeItemData">
          <div class="top-line"
            :style="activeItemData.viewLineStyle.top"></div>
          <div class="bottom-line"
            :style="activeItemData.viewLineStyle.bottom"></div>
        </template>
      </div>
      <div class="view-svg-wrap" :style="viewSvgWrapStyle" ref="viewSvgWrap">
        <svg class="view-svg" :style="viewSvgBoxStyle">
          <template v-for="(item, index) in svgPathItems">
            <path :key="index"
              class="scroll-path"
              :class="eventItemsCssClassData[item.index]"
              :d="item.d"
              @click="$emit('onNodeClick', item)"/>
            <text :key="`text-${index}`"
              class="scroll-text"
              :class="eventItemsCssClassData[item.index]"
              text-anchor="middle"
              alignment-baseline="middle"
              :x="item.textX"
              :y="item.textY">
              {{ item.order }}
            </text>
          </template>
        </svg>

        <template v-if="activeItemData">
          <div class="top-line"
            :style="activeItemData.viewSvgLineStyle.top"></div>
          <div class="bottom-line"
            :style="activeItemData.viewSvgLineStyle.bottom"></div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import AnimateScroll from '@/libs/animate-scroll'

export default {
  name: 'FunnelSessionMobile',
  props: [
    'NODE_TYPE',
    'containerWidth',
    'containerHeight',
    'imageUrl',
    'activeIndex',
    'activeItem',
    'eventItems',
    'nodeItems',
    'eventItemsCssClassData',
    'isActionStart',
    'fitMode',
    'scale',
    'showTimeline',
    'viewportHeight',
    'maxTime'
  ],
  data () {
    return {
      containerScale: 1
    }
  },
  computed: {
    viewStyle () {
      return {
        width: `${this.containerWidth * this.containerScale}px`,
        height: `${this.containerHeight * this.containerScale}px`,
        backgroundImage: `url(${this.imageUrl})`
      }
    },
    viewSvgWrapStyle () {
      return {
        marginLeft: `${this.containerWidth * this.containerScale + 26}px`
      }
    },
    viewSvgBoxStyle () {
      let width = 0

      if (this.svgPathItems.length) {
        const lastItem = this.svgPathItems[this.svgPathItems.length - 1]
        width = lastItem.startX + lastItem.width + 25
      }
      return {
        width: `${width}px`,
        height: `${this.containerHeight * this.containerScale}px`
      }
    },
    activeItemData () {
      if (!this.activeItem || !this.viewportHeight) {
        return null
      }

      const pathItem = this.svgPathItems.find(item => item.index === this.activeIndex)
      const startX = pathItem.startX
      const y = pathItem.y
      const height = pathItem.height
      const viewLinewidth = this.containerWidth * this.containerScale + 26
      const halfWidth = pathItem.halfWidth
      const isUp = pathItem.isUp

      return {
        maskStyle: {
          top: {
            height: `${isUp ? y + height : y}px`
          },
          bottom: {
            top: `${isUp ? y : y + height}px`,
            bottom: 0
          }
        },
        viewLineStyle: {
          top: {
            top: `${y}px`,
            width: `${viewLinewidth}px`
          },
          bottom: {
            top: `${y + height}px`,
            width: `${viewLinewidth}px`
          }
        },
        viewSvgLineStyle: {
          top: {
            top: `${y}px`,
            width: `${startX}px`
          },
          bottom: {
            top: `${y + height}px`,
            width: `${startX + halfWidth}px`
          }
        }
      }
    },
    svgPathItems () {
      const items = []
      let startX = 0
      const viewRenderHeight = this.viewportHeight * this.scale * this.containerScale

      for (let i = 0; i < this.nodeItems.length; i++) {
        const nodeItem = this.nodeItems[i]
        const nodeIndex = nodeItem.index
        let arrowHeight = 10
        let marginX = 15
        let width = 20

        if (this.maxTime) {
          const addedWidth = Math.round(nodeItem.duration / this.maxTime * 10) * 2
          width += addedWidth
          width = Math.min(width, 40)
        }

        if (this.fitMode === 'height') {
          width *= 0.8
          arrowHeight *= 0.8
          marginX *= 0.5
        }

        const isUp = nodeItem.type === 'scrollUp'
        const halfWidth = width / 2
        let height = viewRenderHeight
        const x = nodeItem.x * this.containerScale
        let y = nodeItem.y * this.containerScale

        if (isUp) {
          y += height
          height = -height
          arrowHeight = -arrowHeight
        }
        const d = [
          `M ${startX} ${y}`,
          `l 0 ${height - arrowHeight}`,
          `l ${halfWidth} ${arrowHeight}`,
          `l ${halfWidth} ${-arrowHeight}`,
          `l 0 ${-height + arrowHeight}`,
          'Z'
        ].join(' ')

        items.push({
          d,
          x,
          y,
          startX,
          width,
          height,
          halfWidth,
          isUp,
          textX: startX + halfWidth,
          textY: y + (height / 2),
          order: nodeItem.nodeData.order,
          index: nodeIndex
        })

        startX += width + marginX
      }
      return items
    }
  },
  watch: {
    fitMode () {
      this.setContainerScale()
    },
    showTimeline () {
      this.setContainerScale()
    },
    activeItem (value) {
      if (!value) {
        return
      }

      const container = this.$refs.viewSvgWrap
      const pathItem = this.svgPathItems.find(item => item.index === value.index)

      if (container) {
        if (!this.scroller) {
          this.scroller = new AnimateScroll(container)
        }

        let offsetLeft = pathItem.startX

        if (pathItem.order > 1) {
          offsetLeft -= 25
        }
        this.scroller.scrollTo({ x: offsetLeft }, 300)
      }
    }
  },
  methods: {
    setContainerScale () {
      if (this.fitMode === 'width') {
        this.containerScale = 1
      } else {
        const boxHeight = this.$el.offsetHeight - 80
        this.containerScale = boxHeight / this.containerHeight
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.top-line,
.bottom-line {
  position: absolute;
  left: 0;
  z-index: 20;
  border-top: 1px dashed #fff;
}

.view-area-box {
  position: relative;
  height: 100%;
  box-sizing: border-box;
  padding: 40px 0;
  margin-left: 85px;
  overflow-x: hidden;
  overflow-y: auto;
  &.fit-height {
    padding-bottom: 20px;
  }
}

.view {
  position: relative;
  z-index: 20;
  float: left;
  background-repeat: no-repeat;
  background-size: 100%;

  .mask-top,
  .mask-bottom {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    opacity: 0.6;
    background-color: #252d3c;
  }
  .mask-top {
    height: 100%;
  }
}

.view-svg-wrap {
  position: relative;
  overflow-x: auto;
  overflow-y: hidden;
}

.view-svg {
  overflow: visible;
}

.scroll-path {
  stroke-width: 0;
  fill-opacity: 0.2;
  cursor: pointer;

  &.node-scroll-down {
    fill: #fff;
  }
  &.node-scroll-up {
    fill: #ff8400;
  }
  &.active {
    cursor: default;
    transition: fill-opacity 0.3s;
    fill-opacity: 1;
  }
}

.scroll-text {
  fill: #1b1b1b;
  font-size: 12px;
  font-weight: 600;
  pointer-events: none;
  &.active {
    fill: #2f2f2f;
  }
}
</style>
